import { Pagination, Table, Tag, Typography } from "antd";
import ChangeDealerCode from "../../components/common/changeDealerCode";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { GetDealerOrderRequestsList } from "../../../redux/actions/userActions/ordersActions";
import { Link, useLocation } from "wouter";
import { getQueryParams } from "../../../utilities/getQueryParams";
import { useLoader } from "../../../utilities/useLoader";

const { Title } = Typography;
const OrderRequestList = () => {
  const authData = useSelector((state) => state.auth_store);
  const dealer_code = authData?.defaultDealerCode;
  const [ordersList, setOrdersList] = useState([]);
  const [, navigate] = useLocation();
  const params = getQueryParams();
  const initialPage = params.page || 1;
  const [currentPage, setCurrentPage] = useState(initialPage);
  const [totalOrders, setTotalOrders] = useState(0);
  const [loader, startLoader, endLoader] = useLoader();
  const handlePageChange = (page) => {
    setCurrentPage(page);
    navigate(`/order-requests?page=${page}`);
  };
  const dispatch = useDispatch();
  useEffect(() => {
    startLoader();
    dispatch(
      GetDealerOrderRequestsList({
        dealerCode: dealer_code,
        page: currentPage,
        perPage: 10,
      })
    )
      .then((res) => {
        setOrdersList(res?.payload?.data?.data);
        setTotalOrders(res?.payload?.data?.pagination?.total);
        endLoader();
      })
      .catch((error) => {
        console.error("Error fetching orders:", error);
      });
  }, [dispatch, setOrdersList, dealer_code, currentPage]);
  const columns = [
    {
      title: "Order Id",
      dataIndex: "primaryId",
      key: "primaryId",
      // fixed: "left",
      render: (text) => <Link to="#">{text}</Link>,
    },
    {
      title: "Order Total",
      dataIndex: "orderTotal",
      key: "orderTotal",
    },
    {
      title: "Order Type",
      dataIndex: "orderType",
      key: "orderType",
    },
    {
      title: "Requested Date",
      dataIndex: "requestedDate",
      key: "requestedDate",
    },
    {
      title: "Placed At",
      dataIndex: "placedAt",
      key: "placedAt",
    },
    {
      title: "Status",
      key: "status",
      dataIndex: "status",
      render: (status, record) => {
        let color =
          status === "approved"
            ? "green"
            : status === "error"
            ? "red"
            : "geekblue";
        return (
          <Tag
            color={color}
            key={status}
            className="font-bold"
            style={{ cursor: status === "Error" ? "pointer" : "default" }}
          >
            {status.toUpperCase()}
          </Tag>
        );
      },
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (record) => (
        <Link
          to={`/order-details?orderId=${record.primaryId}`}
          className="text-red-600"
        >
          View
        </Link>
      ),
    },
  ];
  return (
    <div className="bg-gray-50 rounded-lg m-4 p-4 shadow-lg">
      <div className="sm:flex justify-between items-center">
        <Title level={2}>Order Request</Title>
        <ChangeDealerCode />
      </div>
      <Table
        className="max-sm:overflow-x-scroll max-w-full"
        columns={columns}
        dataSource={ordersList}
        pagination={false}
        loading={loader}
      />
      <div className="flex justify-between items-center mt-4">
        <Pagination
          current={currentPage}
          total={totalOrders}
          pageSize={10}
          onChange={handlePageChange}
          showSizeChanger={false}
        />
      </div>
    </div>
  );
};
export default OrderRequestList;
